import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import MainSection from '_/common/components/layout/MainSection';
import { useAuth } from '_/contexts/AuthContext';
import useDocumentTitle from '_/hooks/useDocumentTitle';
import { useAllOrganizations, useMyOrganizations } from '_/hooks/useOrganizations';
import React, { ReactElement } from 'react';

import Organizations from './Organizations';

function OrganizationsContainer(): ReactElement {
  const { isSuperAdmin: superAdmin } = useAuth();

  const { isLoading: isLoadingAll } = useAllOrganizations(!!superAdmin);
  const { isLoading: isLoadingMy } = useMyOrganizations();

  useDocumentTitle('Import.io :: organizations');

  const isLoading = isLoadingAll || isLoadingMy;

  return (
    <MainSection>
      <AsyncPageContainer isLoading={isLoading}>
        <Organizations superAdmin={superAdmin} />
      </AsyncPageContainer>
    </MainSection>
  );
}

export default OrganizationsContainer;
